$(document).ready(function () {
    // set up the table: sorting, text filter, etc.
    $('#listing').DataTable();
});
